import { Routes, Route, Outlet, useNavigate } from 'react-router-dom';
import Login from '@sdk/login';
import ClockSidebar from '@sdk/login/components/sidebars/ClockSidebar';
import KioskLoginScreen from '@sdk/login/screens/KioskLoginScreen';
import ForgotPasswordScreen from '@sdk/login/screens/ForgotPasswordScreen';

import App from './App';
import OauthRoute from './routes/OauthRoute';

const Routing: React.FC = () => {
  const navigate = useNavigate();

  const goToLogin = (): void => {
    navigate('/setup');
  };

  const goToForgotPassword = (email?: string): void => {
    navigate(`/setup/forgot-password?email=${email}`);
  };

  const redirectToKiosk = (guid: string, usTimeFormat = true, kioskSessionId: number): void => {
    navigate(`/?guid=${guid}&usTimeFormat=${usTimeFormat}&kioskSessionId=${kioskSessionId}`);
  };

  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/setup" element={<Login sidebar={<ClockSidebar />} content={<Outlet />} />}>
        <Route
          path="/"
          element={
            <KioskLoginScreen
              goToForgotPassword={goToForgotPassword}
              redirectToKiosk={redirectToKiosk}
            />
          }
        />
        <Route path="forgot-password" element={<ForgotPasswordScreen goToLogin={goToLogin} />} />
      </Route>
      <Route path="oauth/:provider" element={<OauthRoute />} />
    </Routes>
  );
};

export default Routing;
